import * as Sentry from '@sentry/browser'

export const LEGACY_SELECTION_BEHAVIOR = {
  SPACE_SELECT_ADVANCE: 'space-select-advance',
  TAB_CHECKBOX_JUMP: 'tab-checkbox-jump',
  SHIFT_ROW_RANGE_DIVERGES: 'shift-row-range-diverges',
  SHIFT_COLUMN_RANGE: 'shift-column-range',
}

const recordedThisPageLoad = new Set()

export function recordLegacySelectionUsage(behavior, attributes = {}) {
  const variant = Object.entries(attributes)
    .filter(([, value]) => typeof value === 'boolean')
    .map(([key, value]) => `${key}=${value}`)
  const key = [behavior, ...variant].join(' ')
  if (recordedThisPageLoad.has(key)) return
  recordedThisPageLoad.add(key)

  const environment = Sentry.getClient()?.getOptions().environment || 'production'
  Sentry.captureEvent({
    message: `legacy-selection-usage: ${key}`,
    level: 'info',
    environment: `${environment}-usage`,
    fingerprint: ['legacy-selection-usage', behavior],
    tags: Object.fromEntries(Object.entries({ behavior, ...attributes }).map(([name, value]) => [name, String(value)])),
  })
}

function applyLegacyShiftRange({ selected, clickedIndex, legacyAnchor, checked }) {
  const result = [...selected]
  for (let i = Math.min(clickedIndex, legacyAnchor); i <= Math.max(clickedIndex, legacyAnchor); i++) {
    result[i] = checked
  }
  return result
}

function applyZionShiftRange({ selected, clickedIndex, zionAnchor, zionLastShift }) {
  const result = [...selected]
  if (zionAnchor == null || zionAnchor === clickedIndex) {
    result[clickedIndex] = !selected[clickedIndex]
    return result
  }
  const fill = selected[zionAnchor]
  const first = Math.min(zionAnchor, clickedIndex)
  const last = Math.max(zionAnchor, clickedIndex)
  for (let i = first; i <= last; i++) {
    result[i] = fill
  }
  if (zionLastShift != null && zionLastShift > last) {
    for (let i = last + 1; i <= zionLastShift; i++) result[i] = !fill
  } else if (zionLastShift != null && zionLastShift < first) {
    for (let i = zionLastShift; i < first; i++) result[i] = !fill
  }
  return result
}

export function countShiftRangeDivergence(click) {
  const legacy = applyLegacyShiftRange(click)
  const zion = applyZionShiftRange(click)
  return legacy.filter((value, i) => value !== zion[i]).length
}
